export default "__VITE_ASSET__ab425c38__"